import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { MessagesSquare, Sparkles, Briefcase, Users, Star, ChevronRight } from "lucide-react";

export default function CollabHub() {
  const { t } = useI18n();
  const navigate = useNavigate();
  usePageMeta(t("client_collab_title"));

  const tiles = [
    { key: "chats", to: "/app/collab/chats", icon: MessagesSquare, color: "#5E7A73", title: t("client_collab_tile_chats_title"), sub: t("client_collab_tile_chats_sub") },
    { key: "offerings", to: "/app/collab/offerings", icon: Sparkles, color: "#3E7C6A", title: t("client_collab_tile_offerings_title"), sub: t("client_collab_tile_offerings_sub") },
    { key: "projects", to: "/app/collab/projects", icon: Briefcase, color: "#B87A3E", title: t("client_collab_tile_projects_title"), sub: t("client_collab_tile_projects_sub") },
    { key: "discover", to: "/app/collab/discover", icon: Users, color: "#4B4B7A", title: t("client_collab_tile_discover_title"), sub: t("client_collab_tile_discover_sub") },
    { key: "reviews", to: "/app/collab/reviews", icon: Star, color: "#A64F5C", title: t("client_collab_tile_reviews_title"), sub: t("client_collab_tile_reviews_sub") },
  ];

  return (
    <div className="mx-auto max-w-2xl" data-testid="client-collab-root">
      <div className="mb-6">
        <h1 className="font-display text-3xl text-foreground">{t("client_collab_title")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("client_collab_subtitle")}</p>
      </div>
      <div className="space-y-3">
        {tiles.map((tile) => (
          <button key={tile.key} data-testid={`client-collab-tile-${tile.key}`} onClick={() => navigate(tile.to)}
            className="flex w-full items-center gap-4 rounded-2xl border border-border bg-secondary/60 p-5 text-left transition-colors hover:bg-accent">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full" style={{ backgroundColor: tile.color + "22" }}><tile.icon className="h-5 w-5" style={{ color: tile.color }} /></span>
            <span className="min-w-0 flex-1">
              <span className="block font-display text-base text-foreground">{tile.title}</span>
              <span className="block text-sm text-muted-foreground">{tile.sub}</span>
            </span>
            <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
